// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__FN9KD","open":"style_open__qRWvc","close":"style_close__eV2cR"};